import { createAction, createReducer } from 'deox';

export interface LogoFields {
  forceTenantLogo: boolean;
}

const defaultState: LogoFields = {
  forceTenantLogo: false,
};

export const setForceTenantLogo = createAction(
  'SET_FORCE_TENANT_LOGO',
  resolve => (tenantLogo: Partial<LogoFields>) => resolve(tenantLogo),
);
export const tenantLogoReducer = createReducer(defaultState, handleAction => [
  handleAction(setForceTenantLogo, (state, { payload }) => ({
    ...state,
    ...payload,
  })),
]);

interface MountedState {
  tenantLogo: LogoFields;
}

export const selectForceTenantLogo = (state: MountedState): boolean => {
  return state.tenantLogo.forceTenantLogo;
};

export default tenantLogoReducer;
